import * as React from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
// Catches render errors so the user sees a message instead of a blank screen.
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: undefined };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
    }
    render() {
        const { error } = this.state;
        if (error) {
            return (React.createElement(Box, { sx: { p: 2 } },
                React.createElement(Alert, { severity: "error", action: React.createElement(Button, { color: "inherit", size: "small", onClick: () => window.location.reload() }, "Reload") },
                    React.createElement(AlertTitle, null, "Something went wrong"),
                    error.message),
                React.createElement(Box, { component: "pre", sx: { whiteSpace: 'pre-wrap', fontSize: 12, mt: 2 } }, error.stack)));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
